import AccountsAPIService from '@/modules/accounts/services/apiService'

import ReportView  from '@/modules/reporting/views/report.vue'

export default class AccountsModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.accountsService = new AccountsAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/accounts/invoices',
        name: 'InvoiceList',
        component: () => import('@/modules/accounts/views/invoiceList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Invoices',
          menuLink: '/accounts/invoices',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/invoices/:id',
        name: 'Invoice',
        component: () => import('@/modules/accounts/views/invoice.vue'),
        meta: {
          requiresAuth: true,
          title: 'Invoice',
          menuLink: '/accounts/invoices',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Invoices', link: '/accounts/invoices'}
          ]
        }
      },
      {
        path: '/accounts/invoices/:id/report',
        name: 'InvoiceReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Invoice Report',
          layout: 'Blank',
          report: {
            url: '/reporting/invoices/:id/report',
            variables: ['id']
          },
        }
      },
      {
        path: '/accounts/paymentreceiveds/:id',
        name: 'PaymentReceived',
        component: () => import('@/modules/accounts/views/paymentReceived.vue'),
        meta: {
          requiresAuth: true,
          title: 'Payment Received',
          menuLink: '/accounts/paymentreceiveds',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/paymentreceiveds',
        name: 'PaymentReceivedList',
        component: () => import('@/modules/accounts/views/paymentReceivedList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Payments Received',
          menuLink: '/accounts/paymentreceiveds',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/paymentreceiveds/:id/report',
        name: 'PaymentReceivedReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Payment Received Report',
          layout: 'Blank',
          report: {
            url: '/reporting/paymentreceiveds/:id/report',
            variables: ['id']
          },
        }
      },

      {
        path: '/accounts/overpayments/:id',
        name: 'OverPayment',
        component: () => import('@/modules/accounts/views/overPayment.vue'),
        meta: {
          requiresAuth: true,
          title: 'Overpayment',
          menuLink: '/accounts/overpayments',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/overpayments',
        name: 'OverPaymentList',
        component: () => import('@/modules/accounts/views/overPaymentList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Overpayments',
          menuLink: '/accounts/overpayments',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      
      {
        path: '/accounts/creditnotes/:id',
        name: 'CreditNote',
        component: () => import('@/modules/accounts/views/creditNote.vue'),
        meta: {
          requiresAuth: true,
          title: 'Credit Note',
          menuLink: '/accounts/creditnotes',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/creditnotes',
        name: 'CreditNoteList',
        component: () => import('@/modules/accounts/views/creditNoteList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Credit Notes',
          menuLink: '/accounts/creditnotes',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/accounts/creditnotes/:id/report',
        name: 'CreditNoteReport',
        // JB: Not lazy-loaded to avoid flicker with layout issue
        component: ReportView,
        meta: {
          requiresAuth: true,
          title: 'Credit Note Report',
          layout: 'Blank',
          report: {
            url: '/reporting/creditnotes/:id/report',
            variables: ['id']
          },
        }
      },
      {
        path: '/accounts/configuration',
        name: 'AccountConfiguration',
        component: () => import('@/modules/accounts/views/accountConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Accounts Configuration',
          menuLink: '/accounts/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
          ],
        }
      },
    ]
  }
}
